import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=972479ba&scoped=true"
import script from "./SearchProducts.vue?vue&type=script&lang=js"
export * from "./SearchProducts.vue?vue&type=script&lang=js"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=972479ba&scoped=true&lang=less"
import style1 from "./SearchProducts.vue?vue&type=style&index=1&id=972479ba&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972479ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972479ba')) {
      api.createRecord('972479ba', component.options)
    } else {
      api.reload('972479ba', component.options)
    }
    module.hot.accept("./SearchProducts.vue?vue&type=template&id=972479ba&scoped=true", function () {
      api.rerender('972479ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/SearchProducts.vue"
export default component.exports